
/* eslint-disable */

import { Grid, Paper, TextField, Typography, Box, Autocomplete, FormLabel, FormControl, Button, MenuItem, Menu, Fade, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { toast } from 'react-toastify';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';


import palette from '../../theme/palette';
import { useResponsiveStyles } from '../../utils/responsiveStyles';
import Key from '../../clientVariables.json';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));





const priceListStatusList = ['Active', 'Inactive'];
const aprovedByList = ['Satya Bathula', 'Mahipal', 'kishore', 'James'];

const initialRows = [
  // {
  //   id: 'SB676sf1',
  //   name: 'Resume Views',
  //   description: '',
  //   mou: 'each',
  //   price: 15,
  // },
  // {
  //   id: 'SB676sf2',
  //   name: 'Recruiters',
  //   mou: 'each',
  //   price: 100,
  // },
  // {
  //   id: 'SB676sf3',
  //   name: 'Job Posts',
  //   effectiveDate: new Date(),
  //   expiryDate: new Date(),
  //   mou: "each",
  //   priceOfUnit: 10,
  //   quantity: 1000,
  //   totalPrice: priceOfUnit * quantity,
  // },
  // {
  //   id: 'SB676sf4',
  //   name: 'sfknd',
  //   effectiveDate: new Date(),
  //   expiryDate: new Date(),
  //   mou: "each",
  //   quantity: 2,
  // },
  // {
  //   id: 'SB676sf5',
  //   name: 'sfknd',
  //   effectiveDate: new Date(),
  //   expiryDate: new Date(),
  //   mou: "each",
  //   quantity: 2,
  // },
];

function createData(id,priceListName, status, creationDate, createdBy, approvedBy, items) {
  console.log("items check create data", items);
  return {
    id,
    priceListName,
    status,
    creationDate,
    createdBy,
    approvedBy,
    items: items.map(item => ({
      id: item.item_id,
      name: item.name,
      description: item.description,
      type: item.type,
      uom: item.uom,
      price: item.price,
    })),
  };
}




const Price = () => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const initialState = {
    priceListName: '',
    priceListStatus: '',
    creationDate: moment(),
    creetedBy: currentUser?.full_name,
    approvedBy: '',
  }
  const styles = useResponsiveStyles();
  const [formData, setFormData] = useState(initialState);
  const [rows, setRows] = useState(initialRows);
  const [rowModesModel, setRowModesModel] = useState({});

  const [priceListRows, setPriceListRows] = useState([]);

  const [items, setItems] = useState([]);
  const [adminsListData, setAdminsListData] = useState([]);
  const [addItemToPricingList, setAddItemToPricingList] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

useEffect(() => {
  getItems();
  getAdminList();
  getPriceList();
}, []);


  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns = [
    { field: 'id', headerName: 'Item ID', width: 180, editable: true },
    { field: 'name', headerName: 'Item Name', width: 180, editable: true },

    {
      field: 'mou',
      headerName: 'UOM',
      width: 100,
      editable: true,
      // type: 'singleSelect',
      // valueOptions: ['Market', 'Finance', 'Development'],
    },
    {
      field: 'price',
      headerName: 'Price',
      type: 'number',
      width: 80,
      align: 'left',
      headerAlign: 'left',
      editable: true,
    },

    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem icon={<DeleteIcon />} label="Delete" onClick={handleDeleteClick(id)} color="inherit" />,
        ];
      },
    },
  ];


  const getPriceList = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/item/configurations`);
      console.log(response.data);
      
      if (response.status === 200) {
        const priceLists = response.data.data;
        
        
        const priceListRows = priceLists.map(priceList => {
          try {
            const items = JSON.parse(`[${priceList.items}]`);
            console.log(items);
            
            return createData(
              priceList.id,
              priceList.name,
              priceList.status,
              priceList.created,
              priceList.created_by,
              priceList.approved_by,
              items
            );
          } catch (parseError) {
            console.error('Error parsing JSON:', parseError);
            return null; 
          }
        }).filter(row => row !== null);
  console.log("priceListRows", priceListRows);
        setPriceListRows(priceListRows);
      }
    } catch (error) {
      console.error('Error fetching price lists:', error);
      toast.error('Something went wrong try again...');
    }
  };
  
  
  
  
  
  
  

  const submitHandler = async() => {
    // console.log("Final Data Pricing List", formData, rows);
    setSubmitLoading(true);
    try {
      const response = await axios.post(`${Key.domain}/payment/item/pricing`, {
        admin_id: currentUser?.id,
        name: formData?.priceListName,
        status: 1,
        created: moment(formData.creationDate).format('YYYY-MM-DD HH:mm:ss'),
        created_by: currentUser?.id,
        approved_by: formData?.approvedBy?.empcode,
        items: rows,
      });
      if(response.status === 200){
        toast.success("Successfully Added Pricing List", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setRows([]);
        setFormData({
          priceListName: '',
    priceListStatus: '',
    creationDate: moment(),
    creetedBy: currentUser?.full_name,
    approvedBy: '',
        });
        setSubmitLoading(false);
      }
     
    } catch (error) {
      console.error(error);
      setSubmitLoading(false);
      toast.error("Something went wrong try again!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    
  }

  function EditToolbar(props) {
    const { setRows, setRowModesModel, items, setAddItemToPricingList } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    }; 

    const handleMenuItemHandler = async(id) => {
      const data =await getItemById(id);
      console.log("data by id", data);
    }

    const getItemById = async(id) => {
      try {
        const response = await axios.get(`${Key.domain}/payment/items/${id}`);
        if(response.status === 200){
          console.log(response);
          const data = response.data.data[0];
          setAddItemToPricingList(data);
      setRows((oldRows) => [...oldRows, { id: data?.item_id, name: data?.name, mou: data?.uom, price: '', isNew: true }]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: 'price' },
      }));
        }
      } catch (error) {
        console.error(error);
      }
    } 

    // const handleClick = () => {
    //   const id = 'bfdbh';
    //   setRows((oldRows) => [...oldRows, { id, name: '', mou: '', price: '', isNew: true }]);
    //   setRowModesModel((oldModel) => ({
    //     ...oldModel,
    //     [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' },
    //   }));
    // };

    return (
      <GridToolbarContainer>
        <Button color="primary" startIcon={<AddIcon />} 
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        >
          Add Item
        </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {
          items?.map((data) => (
            <MenuItem onClick={() => handleMenuItemHandler(data?.item_id)}>
              {data?.name}
            </MenuItem>
          ))
        }
      </Menu>
      </GridToolbarContainer>
    );
  }

  const handleChange = (feild, value) => {
    setFormData((prev) => ({
      ...prev,
      [feild]: value,
    }));
  };

  const getItems = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/items`);
      if (response.status === 200) {
        console.log(response.data);
        const resData = response.data.data;
        setItems(resData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAdminList = async() => {
    try {
      const response = await axios.post(`${Key.domain}/admin/get_crm_users`, {
        admin_id: currentUser?.id,
        session_token: currentUser?.session_token,
      });
      if (response.status === 200) {
        console.log(response.data);
        const resData = response.data.data;
        setAdminsListData(resData);
      }
    } catch (error) {
      console.error(error);
      toast.error("Admin List Failed try again!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const editPriceListHandler = async(data) => {
    console.log('editPriceList',data);
    const priceList = data;
        
        // const priceListRows = priceLists.map(priceList => {
        //   try {
        //     console.log(items);
            
        //     return createData(
        //       priceList.name,
        //       priceList.status,
        //       priceList.created,
        //       priceList.created_by,
        //       priceList.approved_by,
        //       priceList.items
        //     );
        //   } catch (parseError) {
        //     console.error('Error parsing JSON:', parseError);
        //     return null;
        //   }
        // }).filter(row => row !== null);
  //       const priceListRow = createData(
  //         priceList.priceListName,
  //         priceList.status,
  //         priceList.creationDate,
  //         priceList.createdBy,
  //         priceList.approvedBy,
  //         priceList.items
  //       );
  // console.log("priceListRow edit", priceListRow);
        // setPriceListRows(priceListRow);
        priceList?.items?.map((data) => {
          setRows((oldRows) => [...oldRows, { id: data?.id, name: data?.name, mou: data?.uom, price: data?.price, isNew: false }]);
          // setRowModesModel((oldModel) => ({
          //   ...oldModel,
          //   [id]: { mode: GridRowModes.Edit, fieldToFocus: 'price' },
          // }));
        })
        
      const createdByPrev = adminsListData.filter((item) => item.empcode === data.createdBy);
      const approveedByPrev = adminsListData.filter((item) => item.empcode === data.approvedBy);
      console.log('approveedByPrev', approveedByPrev, createdByPrev);
      setEditId(data.id);
    setFormData((prev) => ({
      ...prev,
      priceListName: data.priceListName,
    priceListStatus: data.status,
    creationDate: moment(data.creationDate),
    creetedBy: createdByPrev[0].UserName,
    approvedBy: approveedByPrev[0],
    }))
    setIsEdit(true);
  }

  const updatePriceList = async(id) => {
    setSubmitLoading(true);
    try {
      const response =await axios.put(`${Key.domain}/payment/item/configurations/${id}`, {
        admin_id: currentUser?.id,
        name: formData.priceListName,
        status: formData.priceListStatus,
        created: moment(formData.creationDate).format('YYYY-MM-DD HH:mm:ss'),
        created_by: currentUser?.id,
        approved_by: formData.approvedBy.empcode,
        items: rows,
      });
      if(response.status === 200){
        toast.success("Successfully Updated Pricing List");
    setSubmitLoading(false);
    getPriceList();

      }
    } catch (error) {
      console.error(error);
      toast.error("Something went Updated Pricing List, try again")
      setSubmitLoading(false);

    }
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
  
    return (
      <>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.id}
          </TableCell>
          <TableCell >
            {row.priceListName}
          </TableCell>
          <TableCell align="right">{row.status}</TableCell>
          <TableCell align="right">{row.creationDate}</TableCell>
          <TableCell align="right">{row.createdBy}</TableCell>
          <TableCell align="right">{row.approvedBy}</TableCell>
          <TableCell align="right">
          <IconButton onClick={() => editPriceListHandler(row)}>
                        <EditIcon  />
                        </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Items
                </Typography>
                {/* Example of history table; adjust as needed */}
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Item</TableCell>
                      <TableCell >Description</TableCell>
                      <TableCell >Type</TableCell>
                      <TableCell >UOM</TableCell>
                      <TableCell align="right">Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.items.map((data) => (
                      <TableRow key={data.id}>
                        <TableCell component="th" scope="row">{data.id}</TableCell>
                        <TableCell >
                          {data.name}
                        </TableCell>
                        <TableCell>{data.description}</TableCell>
                        <TableCell >{data.type}</TableCell>
                        <TableCell >{data.uom}</TableCell>
                        <TableCell align="right">{data.price}</TableCell>
                        
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }
  
  Row.propTypes = {
    row: PropTypes.shape({
      id: PropTypes.string.isRequired,
      priceListName: PropTypes.string.isRequired,
      status: PropTypes.number.isRequired,
      creationDate: PropTypes.string.isRequired,
      createdBy: PropTypes.number.isRequired,
      approvedBy: PropTypes.number.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          uom: PropTypes.string.isRequired,
          price: PropTypes.string.isRequired,
        })
      ).isRequired,
      history: PropTypes.arrayOf(
        PropTypes.shape({
          amount: PropTypes.number.isRequired,
          customerId: PropTypes.string.isRequired,
          date: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  };
  

  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    // fontSize: styles.fontSize12,
    // fontWeight: 500,
    color: palette.grey[800],
    textTransform: 'capitalize',
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`,
    p: '5px',
  };
  const listItemGridContainerStyles = {
    alignItems: 'center',
  };
  return (
    <Grid
      container
      spacing={1}
      sx={{
        bgcolor: '#F2F4FA',
      }}
    >
      <Grid item xs={12}  sx={{
            '.css-r0m7rw-MuiInputBase-root-MuiOutlinedInput-root': {
              height: '40px',
            },
            p: '10px',
            bgcolor: '#fff'
          }}>
        <Grid
          container
          spacing={2}
          // component={Paper}
          // elevation={2}
          
        >
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ borderBottom: `1px solid ${palette.grey[700]}`, mb: '10px' }}>
              Pricing Configuration
            </Typography>
          </Grid>
          <Grid item container spacing={1} xs={12}>
          <Grid item xs={4}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Price List Name</FormLabel>
              <TextField
                fullWidth
                placeholder="Price List Name"
                size="small"
                value={formData.priceListName}
                onChange={(e) => handleChange('priceListName', e.target.value)}
                // error={Boolean(formErrors.priceListName)}
                // helperText={formErrors.priceListName}
                id="priceListName"
                autoComplete="off"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Price List Status</FormLabel>
              <Autocomplete
                size="small"
                disablePortal
                fullWidth
                options={priceListStatusList}
                getOptionLabel={(option) => option}
                value={formData.priceListStatus !== '' ? formData.priceListStatus : null}
                onChange={(event, newValue) => handleChange('priceListStatus', newValue)}
                renderInput={(params) => <TextField {...params} placeholder="Price List Status" />}
                // error={formErrors.priceListStatus}
                // helperText={formErrors.priceListStatus}
                id="priceListStatus"
              />
              {/* {formErrors.priceListStatus && (
                  <Typography color="error" variant="caption">
                    {formErrors.priceListStatus}
                  </Typography>
                )} */}
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Creation Date</FormLabel>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileDatePicker
                  disabled
                  value={formData.creationDate}
                  onChange={(newValue) => handleChange('creationDate', newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Created By</FormLabel>
              <TextField
                fullWidth
                disabled
                placeholder="Created By"
                size="small"
                value={formData.creetedBy}
                onChange={(e) => handleChange('creetedBy', e.target.value)}
                // error={Boolean(formErrors.creetedBy)}
                // helperText={formErrors.creetedBy}
                id="creetedBy"
                autoComplete="off"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Approved By</FormLabel>
              <Autocomplete
                size="small"
                disablePortal
                fullWidth
                options={adminsListData}
                getOptionLabel={(option) => `${option.empcode} - ${option.UserName}`}
                value={formData.approvedBy !== '' ? formData.approvedBy : null}
                onChange={(event, newValue) => handleChange('approvedBy', newValue)}
                renderInput={(params) => <TextField {...params} placeholder="Approved By" />}
                // error={formErrors.approvedBy}
                // helperText={formErrors.approvedBy}
                id="approvedBy"
              />
              {/* {formErrors.approvedBy && (
                  <Typography color="error" variant="caption">
                    {formErrors.approvedBy}
                  </Typography>
                )} */}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                // height: 500,
                width: '100%',
                '& .actions': {
                  color: 'text.secondary',
                },
                '& .textPrimary': {
                  color: 'text.primary',
                },
              }}
            >
              <DataGrid
                autoHeight
                rows={rows}
                columns={columns}
                editMode="row"
                rowModesModel={rowModesModel}
                onRowModesModelChange={handleRowModesModelChange}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                hideFooter
                pagination={false}
                slots={{
                  toolbar: EditToolbar,
                }}
                slotProps={{
                  toolbar: { setRows, setRowModesModel, items, setAddItemToPricingList },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <Button variant="contained" sx={{ width: 150 }} disabled={submitLoading} onClick={() => {isEdit ? updatePriceList(editId) : submitHandler()}}>
              {submitLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              isEdit ? "Update" : "Save"
            )}
              </Button>
            </Box>
          </Grid>
          </Grid>
          
        </Grid>
      </Grid>
      <Grid item xs={12}>
          <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>ID</TableCell>
            <TableCell>Price List Name</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Creation Date</TableCell>
            <TableCell align="right">Created By</TableCell>
            <TableCell align="right">Approved By</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {priceListRows?.map((row) => (
            <Row key={row.priceListName} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
          </Grid>
    </Grid>
  );
};

export default Price;
